<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="HomeIcon"
            icon-right
            :statistic="view_data.number"
            statisticTitle="Unit/Suite No." />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="Maximize2Icon"
            icon-right
            :statistic="view_data.unit_square_feet+'sqm'"
            statisticTitle="Total Area" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="EditIcon"
            icon-right
            statistic="0%"
            statisticTitle="Votes CPI" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="DollarSignIcon"
            icon-right
            :statistic="'$'+view_data.hoa_fee"
            statisticTitle="Monthly Fee" />
      </div>
    </div>

     <vx-card title="Unit Details" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Number</td>
                <td>{{ view_data.number }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ view_data.property.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">HOA Fee</td>
                <td>{{ view_data.hoa_fee }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Unit Square Feet</td>
                <td>{{ view_data.unit_square_feet }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Parking Number</td>
                <td>{{ view_data.parking_stall_number }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'app-unit-edit', params: { editId: $route.params.viewId }}" 
            :disabled="!showU">Edit <!-- crud -->
            </vs-button> 
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" 
            :disabled="!showD">Delete <!-- crud -->
            </vs-button>
          </div>

        </div>

      </vx-card>

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div class="vx-row">
      <div class="vx-col lg:w-1/2 w-full">
        <vx-card title="Unit Owner Resident" class="mb-base">
          <UnitResidentList></UnitResidentList>
        </vx-card>
      </div>

      <div class="vx-col lg:w-1/2 w-full">
        <vx-card title="Unit Owner Non-Resident" class="mb-base">
          <UnitResidentNrList></UnitResidentNrList>
        </vx-card>
      </div>
    </div>     

    <!-- <div id="user-data" v-if="user_data">
      <vx-card>
        <div slot="no-body" class="tabs-container px-6 pt-6">

          <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
            <vs-tab label="Requests" icon-pack="feather" icon="icon-chevron-left">
              <div class="tab-text">
                <agGridRequests></agGridRequests>
              </div>
            </vs-tab>
            <vs-tab label="Users" icon-pack="feather" icon="icon-chevron-left">
              <div class="tab-text">
                <agGridRequests></agGridRequests>
              </div>
            </vs-tab>
            <vs-tab label="Customizations" icon-pack="feather" icon="icon-chevron-left">
              <div class="tab-text">
                <agGridRequests></agGridRequests>
              </div>
            </vs-tab>
            <vs-tab label="Billings" icon-pack="feather" icon="icon-chevron-left">
              <div class="tab-text">
                <agGridRequests></agGridRequests>
              </div>
            </vs-tab>
          </vs-tabs>

        </div>
      </vx-card>
    </div> -->
  </div>
</template>

<script>
import EditTabAccount     from './tabs/EditTabAccount.vue'
import EditTabPermission     from './tabs/EditTabPermission.vue'
import EditTabInformation from './tabs/EditTabInformation.vue'
import EditTabSocial      from './tabs/EditTabSocial.vue'

import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import agGridRequests from './agGrid-requests/agGrid.vue'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import UnitResidentList from '../../unit_resident/list/List.vue'
import UnitResidentNrList from '../../unit_resident/list/List_nr.vue'

import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud

export default {
  components: {
    EditTabAccount,
    EditTabPermission,
    EditTabInformation,
    EditTabSocial,

    agGridRequests,
    StatisticsCardLine,

    UnitResidentList,
    UnitResidentNrList
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      user_data: null,
      user_not_found: false,

      imgs: '',  // Img Url , string or Array of string
      visible: false,
      index: 0,   // default: 0

      token: token,
      
      //unit
      view_data: {
        message: '',
        property_id: '',
        title: ''
      },     
      data_not_found: false,

      //reading docs
      tableRead: [],
      files: [],
      fileKey: []       
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field  } `
      }
      return str
    }
  },
  methods: {
    showMultiple(k) {
      this.index = k  // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },    
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/unit/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-unit-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    //reading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    async loadData () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/unit/view/${viewId}`, {
            headers: { 'Authorization': this.token }
          })
          .then(res => {     
            if(res['data'] == 'access_denied' || res['data'] == '') {
              this.$vs.notify({
                color: 'danger',
                title: 'Error loading',
                text: 'Something went wrong'
              })
              this.$router.push({name:'app-unit-list'})
            } else {
              resolve(res['data'][0])
            }

            this.$vs.loading.close()
          })
          .catch(err => {
            this.data_not_found = true
            this.$vs.loading.close()
          }) 

          //reading docs
          // this.tableRead = await axios.post(`/docs/table/read/`, {
          //   token: this.token,
          //   path: `docs/unit/gallery/${viewId}`,
          //   document_folder_id: 24
          // })

          //reading docs
          // for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
          //   var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
          //   var imgAsc = imgB64.toString('ascii')
          //   this.files.push("data:image/png;base64, " + imgAsc)
          //   this.fileKey.push(value.key)
          // }

          // console.log('this.files ', this.files)
          // console.log('this.fileKey ', this.fileKey)

        } catch(err) {
          reject(err.toString('utf8'));
        }      

        // d.then((res) => {
        //   this.view_data = res[0]
        // })
      })

      this.view_data = await d
    }        
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('unit-list', 'list')
    this.showC = await mainHelper.cansee('unit-create', 'create')
    this.showR = await mainHelper.cansee('unit-read', 'read')
    this.showU = await mainHelper.cansee('unit-update', 'update')
    this.showD = await mainHelper.cansee('unit-delete', 'delete')

    if (!this.showR) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }
    
    this.loadData()

    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const userId = this.$route.params.userId
    this.$store.dispatch('userManagement/fetchUser', userId)
      .then(res => { this.user_data = res.data })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) 
      })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
